module.exports = __webpack_public_path__ + "img/sv113.074b78a3.svg";